import { axiosGet, axiosPost } from '../axios/httpRequest';

/**
 * 查询床位信息列表
 */
export const getNursingBedListApi = params => {
    return axiosGet('api/nursing_bed/v1/nursing_bed', params);
};

/**
 * 公开床位信息
 */
export const getNursingBedOpenListApi = params => {
    return axiosGet('api/nursing_bed/v1/nursing_bed/open', params);
};

/**
 * 获取床位详情
 */
export const getCurrentMenuApi = params => {
    return axiosGet(`api/nursing_bed/v1/nursing_bed/${params.id}`, params);
};

/**
 * 变更护理区域信息
 */
export const postNursingBedApi = params => {
    return axiosPost(`api/nursing_bed/v1/nursing_bed/${params.id}`, params);
};
